module.exports = __webpack_public_path__ + "img/dugout_lounge_tables.b8b313d4.jpg";